const Footer = () => {
  return (
    <footer>
      <div className="footer-wrapper">
        <p>Dung Dao &copy; 2021</p>
      </div>
    </footer>
  );
};

export default Footer;
